import {createSelector} from "@reduxjs/toolkit";
import {plusTestsSelector, testModalSelector, testsDataSelector, testStatusSelector} from "./testsSlice";
import {isEmpty} from "es-toolkit/compat";

export const selectTestData = createSelector([testsDataSelector], data => {
  return !isEmpty(data) ? data : [];
});

export const selectPlusTests = createSelector([plusTestsSelector], plusTests => {
  return !isEmpty(plusTests) ? plusTests : [];
});

export const selectTestModal = createSelector([testModalSelector], modal => {
  return !isEmpty(modal) ? modal : {};
});

export const selectTestStatus = createSelector([testStatusSelector], status => status);
